import React from 'react';

import OrderTemplatesShow from '@components/shared/order_templates/OrderTemplatesShow';
import { useLoaderData } from 'react-router-dom';

export default function OrderTemplateShow() {
  const orderTemplate = useLoaderData();

  return (
    <OrderTemplatesShow
      orderTemplate={orderTemplate}
      role="admin"
    />
  );
}
